import React from "react";
import styled from "styled-components";
import device from "../helpers/device";

export default function Movie({ ...props }) {
  return (
    <Wrapper {...props}>
      <Container>
        <iframe
          title="movie"
          src="https://player.vimeo.com/video/315374855"
          width="640"
          height="360"
          frameBorder="0"
          allowFullScreen
        />
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 25px auto 0 auto;
  width: 90%;
  @media ${device.mobileL} {
    width: 711px;
    margin: 50px auto 0 auto;
  }
`;

const Container = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  height: auto;
  border: 1px solid #3f261f;
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
